export default __webpack_public_path__ + "static/dmz-5224dc0538a8d5222f7b2204a43b6856.png";